import { render, staticRenderFns } from "./informacionAviso.vue?vue&type=template&id=46bd029e&"
import script from "./informacionAviso.vue?vue&type=script&lang=js&"
export * from "./informacionAviso.vue?vue&type=script&lang=js&"
import style0 from "./informacionAviso.vue?vue&type=style&index=0&id=46bd029e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports